export default `
  query listPlatformAdmins {
    listPlatformAdmins {
      userId
      email
      role
    }
  }
`
